class HomeTile extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-hometile-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                900: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            },
            navigation: {
                nextEl: '[data-hometile-next]',
                prevEl: '[data-hometile-prev]',
            },
        });
    }
}
